import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { parseDate, isValid } from "../util/date.js";
var rentContractToMainRentObjectTransaction = function rentContractToMainRentObjectTransaction(rentContract) {
  return rentContract.rentObjTransacts.find(function (_ref) {
    var transactType = _ref.transactType;
    return transactType === "RC";
  }) || {};
};
export var rentContractToSelectedCoStationId = function rentContractToSelectedCoStationId(rentContract) {
  var mainTransaction = rentContractToMainRentObjectTransaction(rentContract);
  return mainTransaction.pickupStationId || mainTransaction.coStationId;
};
export var rentContractToCiStationId = function rentContractToCiStationId(rentContract) {
  return rentContractToMainRentObjectTransaction(rentContract).planCiStationId;
};
export var rentContractToCoDateTime = function rentContractToCoDateTime(rentContract) {
  return parseDate(rentContractToMainRentObjectTransaction(rentContract).coDateTime);
};
export var rentContractToCoDate = function rentContractToCoDate(rentContract) {
  var coDateTimeString = rentContractToMainRentObjectTransaction(rentContract).coDateTime;
  var _ref2 = isValid(coDateTimeString) ? coDateTimeString.split("T") : [],
    _ref3 = _slicedToArray(_ref2, 1),
    date = _ref3[0];
  return date;
};
export var rentContractToCiDateTime = function rentContractToCiDateTime(rentContract) {
  return parseDate(rentContractToMainRentObjectTransaction(rentContract).ciDateTime);
};
export var rentContractToCiDate = function rentContractToCiDate(rentContract) {
  var ciDateTimeString = rentContractToMainRentObjectTransaction(rentContract).ciDateTime;
  var _ref4 = isValid(ciDateTimeString) ? ciDateTimeString.split("T") : [],
    _ref5 = _slicedToArray(_ref4, 1),
    date = _ref5[0];
  return date;
};
export var rentContractToClassificationId = function rentContractToClassificationId(rentContract) {
  return rentContractToMainRentObjectTransaction(rentContract).classificationId;
};